import Content from '../components/layout/Content';
import AdjustmentsForm from '../components/AdjustmentsForm';

const AdjustmentsView = ({ adjustmentType, ...props }) => (
  <Content>
    <AdjustmentsForm
      key={adjustmentType}
      adjustmentType={adjustmentType}
      {...props}
    />
  </Content>
);

export default AdjustmentsView;
